import React, { useState, useEffect, useMemo } from 'react'
import classNames from 'classnames'
import request from '../../utils/request'
import Modal from '../modal'
import Input from '../../baseComponent/input'
import Switch from '../../baseComponent/switch'
import LazyLoadImage from '../../baseComponent/lazyLoadImage'
import { TabTDCell } from '../tabTD'
import { getTeamInfo } from '../../common/userInfo'
import './index.less'

export default ({ visible, onClose, tabValue = 'AUDITOR', modalClassName }) => {
  return <Modal
    title="全局设置(管理员)"
    open={visible}
    onOpenChange={_visible => onClose(_visible)}
    style={{ height: 640, width: 480, paddingBottom: '16px' }}
    className={classNames('meinian-examine-users-modal', modalClassName)}
    hiddenFooter
    onClose={() => onClose?.()}
  >
    <div style={{ padding: '0 24px' }}>
      <GlobalSettingSubject tabValue={tabValue} />
    </div>
  </Modal>
}

export const GlobalSettingSubject = ({ tabValue = 'AUDITOR', className, hiddenSampleSetting = true }) => {
  const teamInfo = getTeamInfo()
  const [keyWord, setKeyWord] = useState()
  const [allUsers, setAllUsers] = useState([])
  const [tab, setTab] = useState(tabValue)
  useEffect(() => {
    setKeyWord(undefined)
    fetchAllUsers()
  }, [])

  const authOrdinary = useMemo(() => {
    const memberType = [1, 2]// 不是超级管理员和管理员的时候
    return memberType.includes(Number(teamInfo.memberType))
  }, [teamInfo])

  const TABS = useMemo(() => {
    const _tabs = [{ label: '审核者设置', value: 'AUDITOR' }]
    return _tabs
  }, [authOrdinary])

  useEffect(() => {
    setTab(tabValue)
  }, [tabValue])

  const fetchAllUsers = async () => {
    try {
      const res = await request.sget('/zhikuan/mn/marker/list', { allStaff: 1 }, 'MN_fetchAllUsers')
      const _arrUser = res.sort((a, b) => {
        return b.marker - a.marker
      })
      setAllUsers(_arrUser)
    } catch (err) {
      console.error('fetchAllUsers', err)
    }
  }
  const addMaker = async (userId) => {
    try {
      await request.post('/zhikuan/mn/marker/setup-marker', { userId })
    } catch (err) {
      console.error('setup-marker', err)
    }
  }
  const removeMaker = async (userId) => {
    try {
      await request.post('/zhikuan/mn/marker/cancel-marker', { userId })
    } catch (err) {
      console.error('cancel-marker', err)
    }
  }
  const onSwitch = (user) => {
    user.marker = !user.marker
    user.marker ? addMaker(user.userId) : removeMaker(user.userId)
    setAllUsers(pre => [...pre])
  }

  return <div className={classNames('meinian-examine-setting-modal', className)}>
    <div className="header">
      {
        hiddenSampleSetting ? <div>
          {TABS.map(_tab => {
            return <TabTDCell
              key={_tab.value}
              className="examine-tab"
              size="small"
              active={tab === _tab.value}
              onClick={() => {
                setTab(_tab.value)
              }}
            >{_tab.label}</TabTDCell>
          })}
        </div> : <div className="header-hiddenSampleSetting">审核者设置</div>
      }
      <span className="header-title">
        {authOrdinary && tab == TABS[0].value ? <Input.Search
          scalable
          wrapClassName="search"
          placeholder="搜索关键词"
          allowClear
          value={keyWord}
          onChange={setKeyWord}
          onClear={() => setKeyWord('')}
        /> : null}
      </span>
    </div>
    <div className="auditor-container">
      <div className="description">将团队成员开启审核权限，方可在灵感集中将其设为审核者</div>
      <div className="users">
        {allUsers.filter((m) => {
          if (!keyWord) {
            return 1
          }
          return m.userName?.includes(keyWord) || m.phone?.includes(keyWord)
        }).map(user => <div className="user" key={user.userId}>
          <LazyLoadImage src={user.avatar} />
          <div className="user-name text-overflow">{user.userName}</div>
          <div className="user-phone">{user.phone}</div>
          <div className="meinian-space" />
          <div className="user-phone">{user.marker ? '允许审核' : '不允许审核'}</div>
          {authOrdinary ? <Switch
            style={{ marginLeft: 16 }}
            active={user.marker}
            onChange={() => onSwitch(user)}
          /> : null}
        </div>)}
      </div>
    </div>
  </div>
}
